
  // Function to set a cookie to prevent repeated redirects
  function setCookieNew(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Function to get a cookie
  function getCookieNew(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Check if user has already been redirected or opted to stay
  if (!getCookieNew('redirected')) {
    // Fetch geolocation data from a free API (e.g., ipapi.co)
    fetch('https://ipapi.co/json/')
      .then(response => response.json())
      .then(data => {
        // Check if the country code is 'GB' (United Kingdom)
        if (data.country_code === 'GB') {
          // Optional: Show a GDPR-compliant confirmation pop-up
        
            // Set a cookie to remember the redirect
           // setCookieNew('redirected', 'true', 2); // Cookie lasts 7 days
            // Redirect to UK store
            window.location.href = 'https://uk.thrivin-gymwear.com';
       
        }
      })
      .catch(error => {
        console.error('Error fetching geolocation:', error);
      });
  }
